/* Store accessibility menu (from Noela, 13.10.26): own code, no third party. Builds its own button + panel at load (the snippet sits in <head>).
   State per visitor in localStorage (try/catch: private windows work, nothing persists). */
(function () {
  if (window.__shA11y) return;
  window.__shA11y = true;
  var KEY = 'sh-a11y-v1';
  var STATEMENT = '/pages/accessibility-statement';
  var TOGGLES = [
    ['contrast', 'ניגודיות גבוהה'],
    ['gray', 'גווני אפור'],
    ['links', 'הדגשת קישורים'],
    ['font', 'גופן קריא'],
    ['motion', 'עצירת אנימציות'],
    ['cursor', 'סמן גדול']
  ];
  var MAX_TEXT = 3, STEP = 0.12;
  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { state = {}; }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  var ICON = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" focusable="false"><circle cx="12" cy="4.2" r="2.2" fill="currentColor"/><path d="M4 7.6c2.6.8 5.3 1.2 8 1.2s5.4-.4 8-1.2l.5 1.9c-2 .6-4.1 1-6.2 1.2v3.6l2.4 7.2-1.9.6-2.6-6.6h-.4l-2.6 6.6-1.9-.6 2.4-7.2v-3.6c-2.1-.2-4.2-.6-6.2-1.2z" fill="currentColor"/></svg>';

  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }

  /* ---- text size: scale the computed size of every element that carries text ---- */
  var scaled = [];
  function restoreText() {
    for (var i = 0; i < scaled.length; i++) { var e = scaled[i]; e.style.fontSize = e.getAttribute('data-na11y-fs-inline') || ''; e.removeAttribute('data-na11y-fs'); e.removeAttribute('data-na11y-fs-inline'); }
    scaled = [];
  }
  function applyText() {
    restoreText();
    var lvl = state.text || 0;
    if (!lvl) return;
    var f = 1 + STEP * lvl;
    var all = document.body.querySelectorAll('*');
    var list = [];
    for (var i = 0; i < all.length; i++) {
      var e = all[i];
      if (e.closest('#na11y-root') || /^(SCRIPT|STYLE|SVG|PATH|IMG|VIDEO|PICTURE|SOURCE|IFRAME|NOSCRIPT|BR)$/i.test(e.tagName)) continue;
      var hasText = false;
      for (var c = e.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && c.nodeValue.trim()) { hasText = true; break; }
      if (hasText) list.push([e, parseFloat(getComputedStyle(e).fontSize)]);
    }
    for (var j = 0; j < list.length; j++) {
      var x = list[j][0], px = list[j][1];
      if (!px) continue;
      x.setAttribute('data-na11y-fs-inline', x.style.fontSize || '');
      x.setAttribute('data-na11y-fs', px);
      x.style.fontSize = (px * f).toFixed(1) + 'px';
      scaled.push(x);
    }
  }

  function applyVideos() {
    var vids = document.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (state.motion) { if (!v.paused) { v.setAttribute('data-na11y-was-playing', '1'); v.pause(); } }
      else if (v.getAttribute('data-na11y-was-playing')) { v.removeAttribute('data-na11y-was-playing'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
  }

  var root, btn, panel, textOut;
  function applyAll() {
    var h = document.documentElement;
    for (var i = 0; i < TOGGLES.length; i++) h.classList.toggle('na11y-' + TOGGLES[i][0], !!state[TOGGLES[i][0]]);
    applyText();
    applyVideos();
    if (panel) {
      var b = panel.querySelectorAll('[data-na11y-toggle]');
      for (var k = 0; k < b.length; k++) b[k].setAttribute('aria-pressed', state[b[k].getAttribute('data-na11y-toggle')] ? 'true' : 'false');
      textOut.textContent = Math.round((1 + STEP * (state.text || 0)) * 100) + '%';
      panel.querySelector('[data-na11y-text="up"]').disabled = (state.text || 0) >= MAX_TEXT;
      panel.querySelector('[data-na11y-text="down"]').disabled = (state.text || 0) <= 0;
    }
  }

  function open() {
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    panel.querySelector('button').focus();
  }
  function close(returnFocus) {
    panel.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    if (returnFocus) btn.focus();
  }

  function build() {
    root = el('div', { id: 'na11y-root', dir: 'rtl', lang: 'he' });
    btn = el('button', { type: 'button', class: 'na11y-btn', 'aria-label': 'תפריט נגישות', 'aria-expanded': 'false', 'aria-controls': 'na11y-panel' }, ICON);
    panel = el('div', { id: 'na11y-panel', class: 'na11y-panel', role: 'dialog', 'aria-modal': 'false', 'aria-labelledby': 'na11y-title' });
    panel.hidden = true;
    var rows = '';
    for (var i = 0; i < TOGGLES.length; i++) rows += '<button type="button" class="na11y-opt" data-na11y-toggle="' + TOGGLES[i][0] + '" aria-pressed="false">' + TOGGLES[i][1] + '</button>';
    panel.innerHTML =
      '<div class="na11y-head"><h2 id="na11y-title" class="na11y-title">נגישות</h2>' +
      '<button type="button" class="na11y-close" aria-label="סגירת תפריט הנגישות">&times;</button></div>' +
      '<div class="na11y-text" role="group" aria-label="גודל טקסט">' +
      '<button type="button" class="na11y-opt" data-na11y-text="down" aria-label="הקטנת טקסט">הקטנה</button>' +
      '<span class="na11y-level" aria-live="polite"></span>' +
      '<button type="button" class="na11y-opt" data-na11y-text="up" aria-label="הגדלת טקסט">הגדלה</button></div>' +
      '<div class="na11y-grid">' + rows + '</div>' +
      '<button type="button" class="na11y-reset">איפוס הגדרות</button>' +
      '<a class="na11y-link" href="' + STATEMENT + '">הצהרת נגישות</a>';
    textOut = panel.querySelector('.na11y-level');
    root.appendChild(btn); root.appendChild(panel);
    document.body.appendChild(root);

    btn.addEventListener('click', function () { panel.hidden ? open() : close(false); });
    panel.querySelector('.na11y-close').addEventListener('click', function () { close(true); });
    panel.addEventListener('click', function (ev) {
      var t = ev.target.closest('button'); if (!t) return;
      var tog = t.getAttribute('data-na11y-toggle'), txt = t.getAttribute('data-na11y-text');
      if (tog) state[tog] = !state[tog];
      else if (txt) state.text = Math.max(0, Math.min(MAX_TEXT, (state.text || 0) + (txt === 'up' ? 1 : -1)));
      else if (t.classList.contains('na11y-reset')) state = {};
      else return;
      save(); applyAll();
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !panel.hidden) close(true); });
    document.addEventListener('click', function (ev) { if (!panel.hidden && !root.contains(ev.target)) close(false); });
  }

  var timer;
  function watch() {
    // carousels and quick views add text after load: re-apply text size and paused video when the DOM changes
    new MutationObserver(function (m) {
      if (!(state.text || state.motion)) return;
      for (var i = 0; i < m.length; i++) if (root.contains(m[i].target)) return;
      clearTimeout(timer); timer = setTimeout(function () { applyText(); applyVideos(); }, 400);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() { build(); applyAll(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
